import { render } from "./DrawerTrigger.vue?vue&type=template&id=4a6c45fa&scoped=true"
import script from "./DrawerTrigger.vue?vue&type=script&lang=js"
export * from "./DrawerTrigger.vue?vue&type=script&lang=js"

import "./DrawerTrigger.vue?vue&type=style&index=0&id=4a6c45fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6c45fa"]])

export default __exports__